import { useEffect, useState } from "react";

export default function useAuthTheme() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("login-theme") || localStorage.getItem("app-theme") || "light"
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("login-theme", theme);
    localStorage.setItem("app-theme", theme);
  }, [theme]);

  return [theme, setTheme];
}
